type Props = {
  name: string;
  summary?: number;
  unit: string;
  url?: string;
};

const CityInfoUnit = ({ name, summary, unit, url }: Props) => {
  return (
    <div className="flex-auto rounded-xl border border-white border-opacity-40 bg-gradient-to-bl from-[#36cfbd79] to-[#20d1bce1] px-4 pt-2 pb-5">
      <p className="mt-2 flex h-[13px] justify-end">
        {url && (
          <a href={url} target="_blank" rel="noreferrer">
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.70785 11.3833C4.61482 12.4763 2.83476 12.4763 1.74167 11.3833C0.64858 10.2903 0.648642 8.5102 1.74167 7.41711L3.94482 5.21396C5.03785 4.12093 6.81792 4.12093 7.91101 5.21396C8.00047 5.30098 8.05159 5.42026 8.05281 5.54564C8.05342 5.6704 8.00412 5.7909 7.91588 5.87914C7.82702 5.96799 7.70714 6.01729 7.58176 6.01607C7.457 6.01547 7.33711 5.96434 7.25008 5.87488C6.51186 5.13666 5.34403 5.13666 4.60633 5.87488L2.40317 8.07804C1.66494 8.81626 1.66494 9.98409 2.40317 10.7218C3.14139 11.46 4.30922 11.46 5.04693 10.7218L7.13993 8.62879C7.22696 8.53933 7.34685 8.48821 7.47161 8.4876C7.59698 8.48638 7.71687 8.53567 7.80573 8.62453C7.89397 8.71278 7.94327 8.83266 7.94266 8.95803C7.94144 9.0834 7.89032 9.20268 7.80086 9.28971L5.70785 11.3827V11.3833ZM9.89433 7.19681C8.80131 8.28984 7.02124 8.28984 5.92815 7.19681C5.83869 7.10978 5.78757 6.9899 5.78635 6.86513C5.78574 6.73976 5.83503 6.61987 5.92328 6.53102C6.01213 6.44277 6.13202 6.39348 6.25739 6.39409C6.38215 6.3953 6.50204 6.44582 6.58907 6.53589C7.3273 7.27411 8.49512 7.27411 9.23283 6.53589L11.436 4.33273C12.1742 3.59451 12.1742 2.42668 11.436 1.68897C10.6978 0.95075 9.52994 0.95075 8.79223 1.68897L6.69922 3.78198V3.78137C6.6122 3.87144 6.49231 3.92257 6.36754 3.92317C6.24217 3.92378 6.12228 3.87449 6.03343 3.78624C5.94518 3.698 5.89589 3.5775 5.8965 3.45274C5.89771 3.32737 5.94884 3.20809 6.0383 3.12045L8.13131 1.02744C9.22433 -0.0655842 11.0044 -0.0655842 12.0975 1.02744C13.1906 2.12047 13.1905 3.90054 12.0975 4.99362L9.89433 7.19681Z"
                fill="white"
              />
            </svg>
          </a>
        )}
      </p>
      <h3 className="mb-2 text-2xl">{name}</h3>
      <p className="font-['Roboto Bold'] mr-1 text-2xl tracking-tighter text-[#FFF5E5]">
        {summary ? (
          <>
            {summary.toLocaleString()}
            <small className="ml-1 text-sm text-white">{unit}</small>
          </>
        ) : (
          <>- -</>
        )}
      </p>
    </div>
  );
};

export default CityInfoUnit;
